module.exports = __webpack_public_path__ + "img/mingcute_question-fill.5e4d0a57.png";